import { useTranslations } from "next-intl";

import { AudioPopoverCover } from "../audio/AudioPopoverCover";

interface MusicPopoverCoverProps {
  categoryName?: string;
  categoryImageUrl?: string;
}

function MusicPopoverCover({ categoryName, categoryImageUrl }: MusicPopoverCoverProps) {
  const t = useTranslations("ClientKeys.MusicCategories");
  return (
    <AudioPopoverCover
      categoryName={categoryName}
      categoryImageUrl={categoryImageUrl}
      activeTrackTitle={t("popover.activeTrackTitle")}
      inactiveTrackTitle={t("popover.inactiveTrackTitle")}
    />
  );
}

MusicPopoverCover.displayName = "MusicPopoverCover";

export { MusicPopoverCover };
export type { MusicPopoverCoverProps };
